import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const FeaturesSection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: 'Shield',
      title: t('features.anonymity'),
      description: t('features.anonymityDesc')
    },
    {
      icon: 'Users',
      title: t('features.exclusiveNetwork'),
      description: t('features.exclusiveNetworkDesc')
    },
    {
      icon: 'Building2',
      title: t('features.directEmployers'),
      description: t('features.directEmployersDesc')
    },
    {
      icon: 'Target',
      title: t('features.hiddenMarket'),
      description: t('features.hiddenMarketDesc')
    },
    {
      icon: 'Lock',
      title: t('features.verifiedProfiles'),
      description: t('features.verifiedProfilesDesc')
    },
    {
      icon: 'Zap',
      title: t('features.smartMatching'),
      description: t('features.smartMatchingDesc')
    }
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            {t('features.title')}
          </h2>
          <p className="text-lg md:text-xl text-gray-600">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-[#0025cc]/10 flex items-center justify-center mb-4">
                <Icon name={feature?.icon} size={24} color="#0025cc" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature?.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;